/** Auth user token key */
const AUTH_USER_TOKEN_KEY = 'ReactAmplify.TokenKey';

export const AUTH_TYPE = 'IrsYobou.Type';

export const ID_CUST = 'IrsYobou.IdCust';

export default AUTH_USER_TOKEN_KEY;
